module.exports = __webpack_public_path__ + "static/img/part_2_red.a74e6218.png";